import { createAsyncThunk } from "@reduxjs/toolkit";
import { assignRolePrivilege, assignUserPrivilege, createPrivilege, deletePrivilege, fetchAllUsers, fetchPrivilegeTypes, fetchUserPrivileges, updatePrivilege } from "../../../services/PrivilegeService";

// GET thunk
export const getPrivilegeTypes = createAsyncThunk(
  "privilege/fetchTypes",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchPrivilegeTypes();
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

// PUT thunk
export const updatePrivilegeAsync = createAsyncThunk(
  "privilege/updatePrivilege",
  async ({ id, data }, { rejectWithValue }) => {
    
    try {
      const response = await updatePrivilege( id, data );
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

// POST thunk
export const createPrivilegeAsync = createAsyncThunk(
  "privilege/createPrivilege",
  async (data, { rejectWithValue }) => {
    try {
      const response = await createPrivilege(data);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

// DELETE thunk
export const removePrivilege = createAsyncThunk(
  "privilege/delete",
  async (privilegeId, { rejectWithValue }) => {
    try {
      await deletePrivilege(privilegeId);
      return privilegeId; // return id for slice filtering
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const fetchAllUsersAsync = createAsyncThunk(
  "userdata/fetchAllUsers",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchAllUsers();
      return response;
    } catch (error) {
      console.error("Error fetching users:", error);
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

// Fetch User Privileges Thunk
export const fetchUserPrivilegesAsync = createAsyncThunk(
  "userPrivileges/fetchUserPrivileges",
  async (userId, { rejectWithValue }) => {
    try {
      const response = await fetchUserPrivileges(userId);
      return response;
    } catch (error) {
      console.error("Error fetching user privileges:", error);
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

// POST: Assign privilege to user
export const assignUserPrivilegeAsync = createAsyncThunk(
  "userPrivileges/assignUserPrivilege",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await assignUserPrivilege(payload);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

// POST: Assign privilege to role
export const assignRolePrivilegeAsync = createAsyncThunk(
  "rolePrivileges/assignRolePrivilege",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await assignRolePrivilege(payload);
      
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);